import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import App from "@/App";
import Header from "@/pages/Header";
import { Pages } from "@/shared/Constants";
import Footer from "@/pages/Footer/Footer";
import ProtectedRoute, { AdminOnlyRoute, ClientProfileRoute } from "./AuthGuard";
import UserView from "@/pages/UserView";
import ClientProfilePage from "@/pages/ClientProfilePage";
import Dashboard from "@/pages/Dashboard";
import FaultLogEditPage from "@/pages/Dashboard/FaultLogEditPage";
import Administration from "@/pages/Administration";

const AppRoutes: React.FC = () => {
  return (
    <>
      <Header />
      <div className="ms-2 me-2 mb-5">
        <Routes>
          {/* Main App Routes with Sidebar */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <App />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path={`/${Pages.dashboard}`} element={<Dashboard />} />
            <Route path={`/${Pages.faultLogDetail}`} element={<FaultLogEditPage />} />

            <Route
              path={`/${Pages.userManagement}`}
              element={
                <AdminOnlyRoute>
                  <UserView />
                </AdminOnlyRoute>
              }
            />
            <Route
              path={`/${Pages.administration}`}
              element={
                <AdminOnlyRoute>
                  <Administration />
                </AdminOnlyRoute>
              }
            />
            <Route
              path={`/${Pages.clientProfile}`}
              element={
                <ClientProfileRoute>
                  <ClientProfilePage />
                </ClientProfileRoute>
              }
            />
          </Route>

          {/* Catch-all Redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default AppRoutes;
